import styled from 'styled-components';

export const WidgetContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  gap: 16px;
`;

export const TaskWidgetCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 220px;
  padding: 16px 24px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.grayVariations.light};
  background: ${({ theme }) => theme.colors.white};
`;

export const TaskWidgetCardDescription = styled.div`
  color: ${({ theme }) => theme.colors.grayVariations.dark};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 16px;
`;

export const TaskWidgetNumber = styled.div`
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  text-align: center;
`;

export const TaskWidgetButton = styled.button<{
  isOpen?: boolean;
}>`
  margin-top: 16px;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  ${({ isOpen, theme }: { isOpen?: boolean; theme: any }) =>
    isOpen
      ? `background: ${theme.colors.tone.lightBlue};
      color: ${theme.colors.allowedColorsToUse.primaryBlue.normal};
      `
      : `background: ${theme.colors.tone.lightRed};
        color: ${theme.colors.allowedColorsToUse.purple.normal};
      `};
`;
